import { render } from "./CookieMessage.vue?vue&type=template&id=30297b02&scoped=true"
import script from "./CookieMessage.vue?vue&type=script&lang=js"
export * from "./CookieMessage.vue?vue&type=script&lang=js"

import "./CookieMessage.vue?vue&type=style&index=0&id=30297b02&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30297b02"]])

export default __exports__